module.exports = __webpack_public_path__ + "static/media/rawDataBackup.9884c39b.csv";